enum ActionTypes {
    GET_MFA_AVAILABILITY_REQUEST = "apps/getMfaAvailabilityRequest",
    GET_MFA_AVAILABILITY_SUCCESS = "apps/getMfaAvailabilitySuccess"
}

export default ActionTypes;
